import React, { useState } from 'react';
import axios from 'axios';
import SearchResultItem from './SearchResultItem';
import { firebaseConfig } from './credentials';
import { FiSearch, FiX } from "react-icons/fi"

const API_KEY = firebaseConfig.apiKey;
// import { placesTypesExclude } from '../utils/data';

export default function PlaceSearch(props) {
    const { setErr, navigation, searchType, select, uid, favVenues, showFav } = props;
    const [keyword, setKeyword] = useState('');
    const [result, setResult] = useState(null);
    const [noResultMsg, setNoResultMsg] = useState(false);
    
    function clear() {
        setResult(null);
        setKeyword('');
        setNoResultMsg(false);
    }
    const search = async event => {
        event.preventDefault();
        const searchInput = document.querySelector('#search');
        const search = searchInput.value;
        console.log('search:', search)
            setErr(null);
            axios
                .request({
                    method: 'post',
                    url: `https://maps.googleapis.com/maps/api/place/autocomplete/json?key=${API_KEY}&types=${searchType === 'place' ? 'geocode' : 'establishment'}&input=${search}`,
                })
                .then((response) => {
                    const arr = [];
                    let counter = 0;
                    let max = response.data.predictions.length;
                    console.log('axios then')
                    const status = response.data.status;
                    if (status == 'OK') {
                        response.data.predictions.forEach(pred => {
                            const { types, place_id, structured_formatting, terms } = pred;
                            const place = {
                                id: place_id,
                                name: structured_formatting.main_text,
                                address: structured_formatting.secondary_text,
                                types: types,
                                // state:terms[terms.length-2].value,
                                // town:terms[terms.length-1].value,
                                state: searchType == 'place' ? terms[terms.length - 2].value : terms[terms.length - 2].value,
                                town: searchType == 'place' ? terms[terms.length - 1].value : terms[terms.length - 3].value,
                            };
                            if (searchType == 'address') {
                                arr.push(place);
                            } else if (searchType == 'place') {
                                if (types.includes('locality')) {
                                    arr.push(place);
                                } else {
                                    setNoResultMsg(true);
                                }
                            } else {
                            }
                            counter++;
                            if (counter == max) {
                                setResult(arr);
                            }
                            setNoResultMsg(false);
                        });
                    } else if (status == 'ZERO_RESULTS') {
                        setNoResultMsg(true);
                    } else {
                        setErr({ code: status, message: status });
                        console.error('error')
                    }
                })
                .catch((e) => {
                    setErr(e);
                });
        // }
    };

    return (
        <div className='PlaceSearch' >
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                backgroundColor: 'var(--drg)',
                borderWidth: 2,
                borderColor: 'var(--ltg)',
                borderRadius: 5,
                marginBottom: 10,
                justifyContent: 'space-between',
            }}>
                <form onSubmit={search} className="formPlaceSearch" >
                    <label htmlFor="search" className="label">
                        Search place  
                        <input
                            name='search'
                            id='search'
                            placeholder="Search"
                            className='inputPlaceSearch'
                            onBlur={() => { if (favVenues) { showFav(true); } }}
                        />
                    </label>
                    <div style={{ flexDirection: 'row' }}>
                        {keyword.length > 0 && <button style={{color: 'var(--wht)', borderWidth: 0}} onClick={() => { clear(); console.log('kleyword', keyword) }}> <FiX style={{ marginLeft: 10 }}/> </button>}
                        <button 
                            style={{color: 'var(--wht)', borderWidth: 0, fontSize: 16}} 
                            type='submit'
                        > 
                            <FiSearch style={{ fontSize: 24}} /> 
                        </button>
                    </div>
                </form>
            </div>
            {noResultMsg && !result && <p style={{ color: 'var(--wht)', textAlign: 'center' }}>No Results</p>}
            {result && result.map(item => <SearchResultItem uid={uid} key={item.id} item={item} setErr={setErr} searchType={searchType} navigation={navigation} select={select} clear={clear} favVenues={favVenues} />)}
            <img alt='Powered_by_google'
                src={'/powered_by_google_on_non_white.png'}
                style={{ alignSelf: 'center', height: 18, width: 144, marginBottom: 10 }}
            />
        </div>
    );
}

const placesTypes = [
    'bar',
    'night_club',
    'restaurant',
];

const fakeResponse = {
    'predictions': [
        {
            'description': 'The Ugly Dog Pub-Cashiers, Frank Allen Road, Cashiers, NC, USA',
            'matched_substrings': [{ 'length': 3, 'offset': 4 }],
            'place_id': 'ChIJIa-PbF4bWYgRbXH2koK2uOg',
            'reference': 'ChIJIa-PbF4bWYgRbXH2koK2uOg',
            'structured_formatting': {
                'main_text': 'The Ugly Dog Pub-Cashiers',
                'main_text_matched_substrings': [{ 'length': 3, 'offset': 4 }],
                'secondary_text': 'Frank Allen Road, Cashiers, NC, USA',
            },
            'terms': [
                { 'offset': 0, 'value': 'The Ugly Dog Pub-Cashiers' },
                { 'offset': 27, 'value': 'Frank Allen Road' },
                { 'offset': 45, 'value': 'Cashiers' },
                { 'offset': 55, 'value': 'NC' },
                { 'offset': 59, 'value': 'USA' },
            ],
            'types': ['bar', 'restaurant', 'food', 'point_of_interest', 'establishment'],
        },
        {
            'description': 'The Ugly Dog Public House- Highlands, South 4th Street, Highlands, NC, USA',
            'matched_substrings': [{ 'length': 3, 'offset': 4 }],
            'place_id': 'ChIJ3ybyrkgeWYgRNGZHPCSd1pc',
            'reference': 'ChIJ3ybyrkgeWYgRNGZHPCSd1pc',
            'structured_formatting': {
                'main_text': 'The Ugly Dog Public House- Highlands',
                'main_text_matched_substrings': [{ 'length': 3, 'offset': 4 }],
                'secondary_text': 'South 4th Street, Highlands, NC, USA',
            },
            'terms': [
                { 'offset': 0, 'value': 'The Ugly Dog Public House- Highlands' },
                { 'offset': 38, 'value': 'South 4th Street' },
                { 'offset': 56, 'value': 'Highlands' },
                { 'offset': 67, 'value': 'NC' },
                { 'offset': 71, 'value': 'USA' },
            ],
            'types': ['bar', 'food', 'point_of_interest', 'establishment'],
        },
    ],
    'status': 'OK',
};
